/**
 * @typedef {Object} DisputeListItemType
 * @property {string} candidateName - The candidate's full name
 * @property {string} startTimeLocal - Start time in local timezone (ISO format)
 * @property {string} endTimeLocal - End time in local timezone (ISO format)
 * @property {number} breakMinutes - Break duration in minutes
 * @property {number} deltaMinutes - Time difference in minutes between candidate and client submissions
 * @property {string} locationTitle - Title/name of the location
 * @property {object|null} candidateTimesheet - Candidate timesheet data
 * @property {object|null} clientTimesheet - Client timesheet data
 * @property {object|null} candidatePenaltyEstimation - Candidate submission's expected/unexpected penalty estimation
 * @property {object|null} clientPenaltyEstimation - Client submission's expected/unexpected penalty estimation
 * @property {boolean} isCandidateTimeEntriesPresent - Whether candidate has submitted time entries
 * @property {number} bookingId - Unique booking identifier
 * @property {number} locationId - Location identifier
 * @property {number} candidateId - Candidate identifier
 * @property {number} bookingStatus - Current booking status code
 */

export default class DisputeListItem {
  constructor(params = {}) {
    this.candidateName = params.candidateName || ''
    this.startTimeLocal = params.startTimeLocal || ''
    this.endTimeLocal = params.endTimeLocal || ''
    this.breakMinutes = params.breakMinutes || 0
    this.deltaMinutes = params.deltaMinutes || 0
    this.locationTitle = params.locationTitle || ''
    this.candidateTimesheet = params.candidateTimesheet || null
    this.clientTimesheet = params.clientTimesheet || null
    this.candidatePenaltyEstimation = params.candidatePenaltyEstimation || null
    this.clientPenaltyEstimation = params.clientPenaltyEstimation || null
    this.isCandidateTimeEntriesPresent =
      params.isCandidateTimeEntriesPresent || false
    this.bookingId = params.bookingId || 0
    this.locationId = params.locationId || 0
    this.candidateId = params.candidateId || 0
    this.bookingStatus = params.bookingStatus || 0
  }

  get hasCandidateTimesheet() {
    return this.candidateTimesheet !== null
  }

  get hasClientTimesheet() {
    return this.clientTimesheet !== null
  }

  get absoluteDeltaMinutes() {
    return Math.abs(this.deltaMinutes)
  }

  get candidatePenaltyDisplayValue() {
    if (!this.hasCandidateTimesheet || !this.candidatePenaltyEstimation) {
      return '-'
    }

    const { unexpectedPenalties } = this.candidatePenaltyEstimation

    return String(unexpectedPenalties || 0)
  }

  get clientPenaltyDisplayValue() {
    if (!this.hasClientTimesheet || !this.clientPenaltyEstimation) {
      return '-'
    }

    const { unexpectedPenalties } = this.clientPenaltyEstimation

    return String(unexpectedPenalties || 0)
  }
}
